import React from 'react'
import PageComponent from './PageComponent'
import PropTypes from 'prop-types'
import {graphql, useStaticQuery} from 'gatsby'
import {get} from 'lodash'
import {GatsbyImage} from 'gatsby-plugin-image'
import PageLogosRow from './PageLogosRow'
import * as routes from '../../constants/routes'
import {Link} from 'gatsby-plugin-react-i18next'

const IntegrationsRow = ({integrationIds, backgroundColor}) => {
    const data = useStaticQuery(graphql`
        {
            allStrapiIntegration {
                edges {
                    node {
                        strapiId
                        logo {
                            image {
                                childImageSharp {
                                    gatsbyImageData(width: 250, placeholder: NONE, layout: CONSTRAINED)
                                }
                            }
                            alt
                        }
                    }
                }
            }
        }
    `)

    const integrationsWithLogo = integrationIds.map((item) => {
        const integration = data.allStrapiIntegration.edges.find((integration) => integration.node.strapiId === item.id)

        return {
            id: item.id,
            logoImageData: get(integration, 'node.logo.image.childImageSharp.gatsbyImageData', null),
            logoImageAlt: get(integration, 'node.logo.alt', null),
        }
    })

    return (
        <PageComponent backgroundColor={backgroundColor}>
            <PageLogosRow>
                {integrationsWithLogo.map((integration) => (
                    <Link key={integration.id} to={routes.INTEGRATIONS}>
                        <GatsbyImage
                            image={integration.logoImageData}
                            alt={integration.logoImageAlt}
                            style={{height: '80px'}}
                        />
                    </Link>
                ))}
            </PageLogosRow>
        </PageComponent>
    )
}

export default IntegrationsRow

IntegrationsRow.propTypes = {
    id: PropTypes.string,
    integrationIds: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
        })
    ),
    backgroundColor: PropTypes.string,
}

IntegrationsRow.defaultProps = {
    integrationIds: [],
    backgroundColor: 'white',
}
